import React, { useEffect } from 'react';
import WatchProductForm from './WatchProductMISCForm'
import { Paper, withStyles } from "@material-ui/core";
import { hasPermission, parseURL } from '../../../sc-utilities';
import { connect } from "react-redux";
import * as actions from "../store/watchProductActions";
import {getProductType} from "../../../sc-admin/SystemCertificate/utils";

const styles = theme => ({
    root: {
        width: `100%`,
        height: 'auto',
        marginTop: '-43px',
        [theme.breakpoints.down('md')]: {
            marginTop: '-21px',
            width: '100%'
        },
        [theme.breakpoints.down('sm')]: {
            marginTop: '-21px',
            width: '100%'
        }
    },
    submit: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    },
    cancel: {
        width: "250px",
        margin: "10px"
    }
});

const WatchProductEditMisc = props => {
    const { product, loading, editable, classes, activeCustomer, translations, permissions, onFetchWatchProduct } = props;
    let searchParams = parseURL(window.location.search);

    const handleSubmit = async data => {
        data['ActiveCustomerID'] = activeCustomer;
        data['updateMISCOnly'] = true;
        data['ProductID'] = searchParams?.productID;
        await props.onEditWatchProduct({ ...data });
    }

    const getSecurazeVersion = (processingSession) => {
        if (processingSession?.ClientType) {
            return `${getProductType(processingSession?.ClientType ?? "", translations)}: ${processingSession?.ClientVersion ?? ""}`;
        }
        return processingSession?.ClientVersion ?? "";
    }

    let initialValues = {
        OperatingSystem: product && product.WatchProduct && product.WatchProduct.OperatingSystem ? product.WatchProduct.OperatingSystem : '',
        OperatingSystemVersion: product && product.WatchProduct && product.WatchProduct.OperatingSystemVersion ? product.WatchProduct.OperatingSystemVersion : '',
        ScreenSize: product && product.WatchProduct && product.WatchProduct.ScreenSize ? product.WatchProduct.ScreenSize : '',
        Processor: product && product.WatchProduct && product.WatchProduct.Processor ? product.WatchProduct.Processor : '',
        DeviceColor: product && product.WatchProduct && product.WatchProduct.DeviceColor ? product.WatchProduct.DeviceColor : '',
        ProductIdentifier: product && product.WatchProduct && product.WatchProduct.ProductIdentifier ? product.WatchProduct.ProductIdentifier : '',
        ANumber: product && product.WatchProduct && product.WatchProduct.ANumber? product.WatchProduct.ANumber : '',
        OemStatus: product && product.WatchProduct && product.WatchProduct.OemStatus ? product.WatchProduct.OemStatus : '',
        OemReason: product && product.WatchProduct && product.WatchProduct.OemReason ? product.WatchProduct.OemReason : '',
        CaseSize: product && product.WatchProduct && product.WatchProduct.CaseSize ? product.WatchProduct.CaseSize : '',
        CaseMaterial: product && product.WatchProduct && product.WatchProduct.CaseMaterial ? product.WatchProduct.CaseMaterial : '',
        SecurazeVersion: getSecurazeVersion(product?.ProcessingSessions?.[0]),
        HardwareID: product && product.HardwareID ? product.HardwareID : '',
        ManufactoryDate: product && product.WatchProduct && product.WatchProduct.ManufactoryDate? product.WatchProduct.ManufactoryDate : '',
        ECID: product && product.WatchProduct.ECID ? product.WatchProduct.ECID : '',
        MEID: product && product.WatchProduct.MEID ? product.WatchProduct.MEID : '',
    };

    let formSettings = {
        Validation: {
        },
        ButtonSubmit: hasPermission(permissions, "product_save")
            ? {
                Title: translations["save"] || "SAVE",
                Color: 'primary'
            }
            : null,
    };

    useEffect(() => {
        const getProduct = async () => {
            await onFetchWatchProduct({ActiveCustomerID: activeCustomer, ProductID: searchParams?.productID});
        }
        getProduct();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (<>< Paper className={classes.root} >
                <WatchProductForm
                    formSettings={formSettings}
                    initialValues={initialValues}
                    handleSubmit={handleSubmit}
                    editable={editable}
                    loading={loading}
                    translations={translations}
                ></WatchProductForm>
            </Paper>
        </>)
}

const mapStateToProps = state => {
    return {
        product: state?.product?.watchProducts?.loaded,
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        permissions: state?.core?.login?.permissions || [],
        translations:
            state.translate && state.translate.translations
                ? state.translate.translations.activeTranslations || {}
                : {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onEditWatchProduct: product => dispatch(actions.editWatchProduct(product)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(WatchProductEditMisc));
